module.exports = __webpack_public_path__ + "static/media/image2.68d4828f.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/carAuthorization/img/image2.png
// module id = 133
// module chunks = 0